// extracted by mini-css-extract-plugin
export default {"status":"stats_status__HSon0","streak":"stats_streak__G3jIW","gitstreakImg":"stats_gitstreakImg__D7HLY"};